{
    "PaginatedList_Search": "Recherche",
    "PaginatedList_Search_NoResults": "Aucune extension correspondant à cette recherche n'a été trouvée",
    "NAME": "PaginatedList"
}